// Authenticate Module
import * as forge from 'node-forge'
import _ from 'lodash'
import { auth as auth_api } from './api'

const sha256 = x => forge.sha256.create().update(x).digest().toHex();
const sha256_custom = (x, y) => forge.sha256.create().update(x).update(y).digest().toHex();
const decode64 = x => forge.util.decodeUtf8(forge.util.decode64((x || '').replace(/_/g, '/').replace(/-/g, '+')));

const auth = {
  auth:undefined,
  UWSS_status: 0,
  profile: undefined, // From JWT's payload (JSON obj)
  token: undefined, // JWT, itself
  exp: undefined, // Token expire timestamp
  isAuthenticated: () => {
    return auth.hash &&
      auth.token &&
      auth.hash === sha256_custom(auth.token, auth.profile.username) &&
      !_.isEmpty(auth.profile) &&
      auth.exp > new Date().getTime() / 1000;
  },

  // login
  login: async (username, password, otp) => {
    let p = { username: username, password: sha256(password), otp : otp, ts: new Date().valueOf() }
    try {
      let rs = await auth_api.login(p);
      if(!rs || typeof(rs) !== 'string' || !auth.resolve(rs)) { throw { status: 301, data : rs }; }

      sessionStorage.setItem('token', rs);
      console.log('[svc] auth', 'login()', 'success');
      return true;
    } catch(e) {
      console.log('[svc] auth', 'login()', 'failed', e.status, e.data);
      throw e;
    }
  },
  preflight: async (username, password) => {
    let p = { username: username, password: sha256(password), ts: new Date().valueOf() }
    try {
      let rs = await auth_api.preflight(p);

      console.log('[svc] auth', 'preflight()', 'success');
      return rs;
    } catch(e) {
      console.log('[svc] auth', 'preflight()', 'failed', e.status, e.statusText);
      throw e;
    }
  },
  // logout, flush session storage and reset this object.
  logout: () => {
    try { auth.profile ? localStorage.removeItem(sha256(auth.profile.username)) : '' } catch (e) { console.log("try cache info, but was deleted") }
    auth.profile = auth.token = auth.exp = undefined;
    sessionStorage.removeItem('token');
    auth_api.unsetAuth();
  },
  refresh: async () => {
    try {
      let rs = await auth_api.refresh();
      if(!rs || typeof(rs) !== 'string' || !auth.resolve(rs)) { throw { status: 301, data : rs }; }
      sessionStorage.setItem('token', rs);
      console.log('[svc] auth', 'refresh()', 'success');
      return true;
    } catch(e) {
      auth_api.unsetAuth();
      console.log('[svc] auth', 'refresh()', 'failed', e, e.status, e.data);
      return false;
    }
  },
  checkPasswordCycle: async (m) => {
    try {
      let rs = await auth_api.checkPasswordCycle(m);
      console.log('[svc] auth', 'checkPasswordCycle', 'pass');
      return rs;
    } catch(e) {
      console.log('[svc] auth', 'checkPasswordCycle', 'failed', e.status, e.statusText);
      throw e;
    }
  },
  resolve: (token, renew=true) => {
    let ts = {}, rs = [];
    try {
      rs = token.split('.');
      if(rs.length != 3) { return false; }
      let info = decode64(rs[1]);
      ts = JSON.parse(info.replace(/\0/g, '')) || {};
      if(_.isEmpty(ts) || !ts.exp || ts.exp < new Date().getTime() / 1000) { return false; }
    } catch(e) { return false; }

    auth.token = token;

    auth.license = JSON.parse(ts.license);
    auth.profile = ts.profile;

    console.log('start with', localStorage['UWSS_LANG'])

    if(auth.profile.permissions) {
      auth.profile.permissions = auth.profile.permissions.toLowerCase()
    }
    if(renew) {
      auth.hash = sha256_custom(token, auth.profile.username)
      console.log('[svc] auth', 'renewal access info');
    }
    auth.profile.username && auth.hash ? localStorage.setItem(sha256(auth.profile.username), auth.hash) : ''
    auth_api.setAuth(token);
    auth.exp = ts.exp;
    return true;
  },
  init: async () => {
    if(auth.resolve(sessionStorage.getItem('token'), false)) {
      console.log('[svc] auth', 'init()', 'stored token found, verifying.');
      try {
        // 토큰 인젝션 탐지를 위한 1차 검증, 백엔드에서도 검증 필요
        if(localStorage.getItem(sha256(auth.profile.username)) != sha256_custom(auth.token, auth.profile.username)) {
          console.log('[svc] auth', 'init()', 'token injected.');
          throw null
        }
        if(!await auth.refresh()) { throw null; }
        console.log('[svc] auth', 'init()', 'token verified.');
      }
      catch { console.log('[svc] auth', 'init()', 'verifying failed.'); }
    } else {
      console.log('[svc] auth', 'init()', 'stored token not found.');
      sessionStorage.removeItem("token")
    }
  },
  has_level: (levels = []) => { return _.isEmpty(levels) || _.includes(levels, auth.profile.level); }
}

export default auth
